export const getTextures = ({ compressed = true } = {}) => {
    const path = `/textures/ticket`;
    const ext = compressed ? '-etc1s.ktx2' : '@lg.webp#texture';

    // const path = `/textures/ticket/_test`;
    // const ext = compressed ? '-etc1s.ktx2' : '.png#texture';

    return {
        mapDiffuseGold: `${path}/diffuse-gold@pow2${ext}`,
        mapDiffuseInner: `${path}/diffuse-inner@pow2${ext}`,
        mapNormal: `${path}/normal@pow2${ext}`,
        mapSticker: `${path}/sticker${ext}`,
    };
};
